import { Grid, SelectChangeEvent, useEventCallback } from '@mui/material';
import { PmiButton } from 'shell/components/shared/button';
import { FormikProps } from 'formik';
import PmiTextField from 'shell/components/shared/text-field';
import { DatePicker } from '@mui/lab';
import { ArchiveAnnotationsForm } from 'civil-status/view-models/archive-annotations-list';
import { memo } from 'react';
import ListAnscValoriDominio from 'civil-status/components/shared/list-ansc-valori-dominio';
import { DomainType } from 'civil-status/constants/domain';
import { CodeScope } from 'civil-status/constants/code-scope';
import ListRegister from 'civil-status/components/shared/list-register';

interface FormFiltersArchiveProps {
  filters: FormikProps<ArchiveAnnotationsForm>;
}

const FormFiltersArchiveAnnotationsComponent = ({
  filters,
}: FormFiltersArchiveProps): React.ReactElement => {
  const onChangeRegister = useEventCallback((event: SelectChangeEvent<string>) => {
    filters.setFieldValue('typeEvent', event.target.value);
  });

  const onChangePractice = useEventCallback((event: SelectChangeEvent<string>) => {
    filters.setFieldValue('practice', event.target.value);
  });

  return (
    <form onSubmit={filters.handleSubmit} onReset={filters.handleReset}>
      <Grid container spacing={2}>
        <Grid item xs={12} md={2}>
          <ListAnscValoriDominio
            label="Stato"
            value={filters.values.state || ''}
            onChange={(el) => filters.setFieldValue('state', el)}
            error={filters.touched.state && Boolean(filters.errors.state)}
            idDominio={DomainType.Archive}
            idValoreAnsc={CodeScope.ARCHIVIO}
          />
        </Grid>
        <Grid item xs={12} md={2}>
          <DatePicker
            label="Formazione da"
            aria-label="Formazione da"
            value={filters.values.startDate || null}
            onChange={(date) => filters.setFieldValue('startDate', date)}
            renderInput={(params) => (
              <PmiTextField
                {...params}
                id="startDate"
                error={filters.touched.startDate && Boolean(filters.errors.startDate)}
                helperText={filters.errors.startDate}
                fullWidth
              />
            )}
          />
        </Grid>
        <Grid item xs={12} md={2}>
          <DatePicker
            label="Formazione a"
            aria-label="Formazione a"
            value={filters.values.endDate || null}
            onChange={(date) => filters.setFieldValue('endDate', date)}
            renderInput={(params) => (
              <PmiTextField
                {...params}
                id="endDate"
                error={filters.touched.endDate && Boolean(filters.errors.endDate)}
                helperText={filters.errors.endDate}
                fullWidth
              />
            )}
          />
        </Grid>
        <Grid item xs={12} md={2}>
          <ListRegister
            label="Pratica"
            value={filters.values.practice || ''}
            error={Boolean(filters.errors.practice) && filters.touched.practice}
            onChange={onChangePractice}
            withNessuno
          />
        </Grid>
        <Grid item xs={12} md={4}>
          <PmiTextField
            label="Intestatari"
            aria-label="Intestatari"
            id="owners"
            fullWidth
            onChange={(event) => {
              filters.setFieldValue('owners', event.target.value);
            }}
            value={filters.values?.owners || ''}
            helperText={filters.errors?.owners}
            error={filters.touched?.owners && Boolean(filters.errors?.owners)}
          />
        </Grid>
        <Grid item xs={12} md={2}>
          <ListRegister
            value={filters.values.typeEvent || ''}
            error={Boolean(filters.errors.typeEvent) && filters.touched.typeEvent}
            onChange={onChangeRegister}
            withNessuno
          />
        </Grid>
        <Grid item xs={12} md={2}>
          <PmiTextField
            label="Anno"
            aria-label="Anno"
            id="year"
            fullWidth
            inputProps={{
              maxLength: '4',
            }}
            onChange={(event) => {
              filters.setFieldValue('year', event.target.value);
            }}
            value={filters.values?.year || ''}
            helperText={filters.errors?.year}
            error={filters.touched?.year && Boolean(filters.errors?.year)}
          />
        </Grid>
        <Grid item xs={12} md={2}>
          <PmiTextField
            aria-label="Numero"
            label="Numero"
            id="number"
            name="number"
            fullWidth
            type="text"
            variant="outlined"
            value={filters.values?.number || ''}
            onChange={(event) => filters.setFieldValue('number', event.target.value)}
            error={filters.touched?.number && Boolean(filters.errors?.number)}
            helperText={filters.errors?.number}
          />
        </Grid>
        <Grid item xs={12} md={2}>
          <PmiTextField
            aria-label="Parte"
            label="Parte"
            id="portion"
            name="portion"
            fullWidth
            type="text"
            variant="outlined"
            inputProps={{
              maxLength: '1',
            }}
            value={filters.values?.portion || ''}
            onChange={(event) => {
              filters.setFieldValue('portion', event.target.value);
            }}
            helperText={filters.errors?.portion}
            error={filters.touched?.portion && Boolean(filters.errors?.portion)}
          />
        </Grid>
        <Grid item xs={12} md={2}>
          <PmiTextField
            aria-label="Serie"
            label="Serie"
            id="serie"
            name="serie"
            fullWidth
            type="text"
            inputProps={{
              maxLength: '2',
            }}
            variant="outlined"
            value={filters.values?.serie || ''}
            onChange={(event) => filters.setFieldValue('serie', event.target.value)}
            error={filters.touched?.serie && Boolean(filters.errors?.serie)}
            helperText={filters.errors?.serie}
          />
        </Grid>
        <Grid item xs={12} md={2}>
          <PmiTextField
            aria-label="Volume"
            label="Volume"
            id="volume"
            name="volume"
            fullWidth
            type="text"
            variant="outlined"
            value={filters.values?.volume || ''}
            onChange={(event) => filters.setFieldValue('volume', event.target.value)}
            error={filters.touched?.volume && Boolean(filters.errors?.volume)}
            helperText={filters.errors?.volume}
          />
        </Grid>
        <Grid item xs={12} md={2}>
          <DatePicker
            label="Registrazione da"
            aria-label="Registrazione da"
            value={filters.values.startDateRegistration || null}
            onChange={(date) => filters.setFieldValue('startDateRegistration', date)}
            renderInput={(params) => (
              <PmiTextField
                {...params}
                id="startDateRegistration"
                error={
                  filters.touched.startDateRegistration &&
                  Boolean(filters.errors.startDateRegistration)
                }
                helperText={filters.errors.startDateRegistration}
                fullWidth
              />
            )}
          />
        </Grid>
        <Grid item xs={12} md={2}>
          <DatePicker
            label="Registrazione a"
            aria-label="Registrazione a"
            value={filters.values.endDateRegistration || null}
            onChange={(date) => filters.setFieldValue('endDateRegistration', date)}
            renderInput={(params) => (
              <PmiTextField
                {...params}
                id="endDateRegistration"
                error={
                  filters.touched.endDateRegistration && Boolean(filters.errors.endDateRegistration)
                }
                helperText={filters.errors.endDateRegistration}
                fullWidth
              />
            )}
          />
        </Grid>

        <Grid item container spacing={2} xs={12} justifyContent="space-between" display="flex">
          <Grid item container spacing={2} xs={12} justifyContent="flex-end" display="flex">
            <Grid item xs={12} md={2}>
              <PmiButton variant="contained" color="secondary" fullWidth type="reset">
                Pulisci
              </PmiButton>
            </Grid>
            <Grid item xs={12} md={2}>
              <PmiButton variant="contained" color="secondary" fullWidth type="submit">
                Cerca
              </PmiButton>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </form>
  );
};

FormFiltersArchiveAnnotationsComponent.displayName = 'Form Filters Archive Annotations component';

const FormFiltersArchiveAnnotations = memo(FormFiltersArchiveAnnotationsComponent);
export default FormFiltersArchiveAnnotations;
